//开发环境
let BASE_API = 'http://192.168.8.205';
let port = ':8573'
let str = window.location.href
let index = str.indexOf(':');
let res = str.substring(0, index);

if (window.location.host != 'localhost:8080' && window.location.host != 'localhost:8081'){
  BASE_API = res + '://' + window.location.host + port

  if(window.location.port){
    let st = window.location.host.substr(0,window.location.host.lastIndexOf(':'))
    BASE_API = res + '://' + st + port
  }else{
    BASE_API = res + '://' + window.location.host + port
    console.log('检测到域名',BASE_API);
  }
}else{
  BASE_API = "http://192.168.8.205" + port;
}
// BASE_API = "http://192.168.8.205" + port;
let ajax = {
  baseUrl:'',
  //AI生成
  completions:'/api/v1/chat/completions/',
  //获取验证码
  getCode:'/api/v1/code/',
  //登录
  userLogin:"/api/v1/login/",
  //登出
  userLogout:'/api/v1/logout/',
  aiChat:'/api/v1/chat/experience/completions/',
  //创建默认知识库
  createdDefaultSpace:'/api/v1/knowledge/space/add/',
  documentUpload:'/api/v1/knowledge/document/upload/',
  //知识库列表
  spaceList:'/api/v1/knowledge/document/list/',
  //同步
  spaceSync:'/api/v1/knowledge/document/sync/',
  aiList:'/api/v1/chat/dialogue/messages/history/',
  //删除知识库文件接口
  delDoc:'/api/v1/knowledge/document/delete/',
  floatChat:'/api/v1/chat/completions/',
  dialogueList:'/api/v1/chat/dialogue/list/',
  docStatus:'/api/v1/knowledge/document/status/'
};
for (let key in ajax){
  ajax[key] = BASE_API + ajax[key]
}
/* 导出api对象 */
export default ajax;



// WEBPACK FOOTER //
// ./src/api/api.js